/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import * as types from "./types";
import http from "@/http";

const actions = {
  [types.FETCH_TRANSLATIONS](context, { type }) {
    const enablePerformanceLogging = this.state.utils.queryParams.enablePerformanceLogging || this.state.utils.configuration.enablePerformanceLogging

    return new Promise((resolve, reject) => {
       http.get(this.state.endPoints[type].translations)
         .then(({ data }) => {
            context.commit(types.SET_TRANSLATIONS, {translations: data});
            if(enablePerformanceLogging)
            console.log("Translations Ready: ", new Date().getTime() / 1000 - this.state.utils.initialTime);

            resolve(data);
          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
    });
  },
  [types.FETCH_UPCHARGE](context, { type }) {
    if (!this.state.utils.configuration.enableUpchargeFromS3) {
      return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
       http.get(this.state.endPoints[type].upcharge)
         .then(({ data }) => {
            context.commit(types.SET_UPCHARGE, {upcharge: data});
            resolve(data);
          })
          .catch(error => {
            console.error(error);
            reject(error);
          });
    });
  }
};

export default actions;
